export const makeSupplement = ({
  supplement
}: {
  supplement: string
}): string => {
  return supplement.includes('+墓石代') ? supplement : ''
}
